import React, { Component } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperInputComponent,
    StatusComponent,
} from "../../../common/component/Index";
import { Link } from 'react-router-dom';
import i18n from "../../../../../constants/initLng";
import { PATHS, TICKET, DETAIL_ACTIONS, DATE_TIME_FORMAT } from "../../../../../constants/Define";
import { Descriptions } from 'antd';
import { isEqual, get, find, toArray } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Ticket from '../../../../../models/Ticket';
import Wrapper from './../../../common/component/Wrapper';
import Input from './../../../common/component/Input';

import './TicketDetail.less';
import { getLocaleFullName } from '../../../../../utils/commonUtils';
import Span from '../../../common/component/Span';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import TextArea from '../../../common/component/TextArea';
import Radio from '../../../common/component/Radio';

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
};

export default class TicketDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            ticket: this.props.isMyTicket ? this.props.ticketState.detail.myTicket : this.props.ticketState.detail.ticket,
            uploadFiles: [],
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    componentWillUnmount() {
        if (this.props.isMyTicket) {
            this.props.setMyTicketDetail(new Ticket())
        } else {
            this.props.setTicketDetail(new Ticket())
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.isMyTicket && nextProps.ticketState.detail.ticket
            && !isEqual(nextProps.ticketState.detail.ticket, this.props.ticketState.detail.ticket)) {
            this.setState({
                ticket: nextProps.ticketState.detail.ticket,
                action: nextProps.ticketState.detail.ticket.id ? DETAIL_ACTIONS.UPDATE : this.state.action
            });
        }
        if (this.props.isMyTicket && nextProps.ticketState.detail.myTicket
            && !isEqual(nextProps.ticketState.detail.myTicket, this.props.ticketState.detail.myTicket)) {
            this.setState({
                ticket: nextProps.ticketState.detail.myTicket,
                action: nextProps.ticketState.detail.myTicket.id ? DETAIL_ACTIONS.UPDATE : this.state.action
            });
        }
    }

    render() {
        const { t, ticketState, userState, isMyTicket } = this.props;
        const { isFetchingDetail } = ticketState;
        const { csUsers } = userState;
        const { action, validation, ticket } = this.state;

        const typeEnum = find(toArray(TICKET.ACTION_TYPE), item => item.id === ticket.actionType);
        const priorityEnum = find(toArray(TICKET.PRIORITY), item => item.id === ticket.priority);
        const statusEnum = find(toArray(TICKET.STATUS), item => item.id === ticket.status);
        return (
            <LoadingComponent spinning={isFetchingDetail}>
                <PageListComponent className="ticket-detail-page">
                    {!isMyTicket &&
                        <HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'tickets'}
                            titleHeader={
                                Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.ticket.title')}`.toLowerCase()))
                            }

                        />
                    }
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isGetItem={false}
                        action={action}
                        onClickBack={this.onClickBack}
                        submitButtonRight={true}
                        disabledFooter={isMyTicket}
                    >
                        <Wrapper className='col-md-12 row m-0 pl-0 pr-0 pt-2 bg-white'>
                            <Wrapper className="col-md-6">
                                <FormWrapperInputComponent
                                    isRequired={true}
                                    classInputForm="col-md-8"
                                    classLabel="col-md-4"
                                    isValidation={true}
                                    dataValidation={ticket.ticketName}
                                    validation={validation.ticketName}
                                    labelTitle={t(`item.ticket.ticketName`)}
                                >
                                    <Input placeholder="" type={`text`}
                                        className={`form-control`}
                                        name={`ticketName`} onChange={(e) => this.onChangeDetail('ticketName', e.target.value)}
                                        value={Func.checkUndefine(ticket.ticketName)} />
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    typeInput={true}
                                    classInputForm="col-md-6"
                                    classLabel="col-md-6"
                                    labelTitle={t(`item.ticket.actionType`)}
                                >
                                    {!!typeEnum && <Span>{t(`item.ticket.actionTypes.${typeEnum.key}`)}</Span>}
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    typeInput={true}
                                    classInputForm="col-md-6"
                                    classLabel="col-md-6"
                                    labelTitle={t(`item.ticket.priority`)}
                                >
                                    {!!priorityEnum && <Span>{t(`item.ticket.priorities.${priorityEnum.key}`)}</Span>}
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    typeInput={true}
                                    classInputForm="col-md-6"
                                    classLabel="col-md-6"
                                    labelTitle={t(`item.ticket.status`)}
                                >
                                    {/* {!!statusEnum && <StatusComponent color={statusEnum.color}
                                        label={t(`item.ticket.statusTypes.${statusEnum.key}`)} />} */}
                                    <Radio.Group value={ticket.status}
                                        onChange={e => this.onChangeDetail('status', e.target.value)}>
                                        {toArray(TICKET.STATUS).map(status => !status.hide &&  (
                                            <Radio key={status.key} value={status.id}>{t(`item.ticket.statusTypes.${status.key}`)}</Radio>
                                        ))}
                                    </Radio.Group>
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    typeInput={true}
                                    classInputForm="col-md-6"
                                    classLabel="col-md-6"
                                    labelTitle={t(`item.ticket.orderCode`)}
                                >
                                    <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: ticket.orderId })} className={`mr-2 colorPrimary`}>
                                        <Span>{ticket.orderCode}</Span>
                                    </Link>
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    typeInput={true}
                                    classInputForm="col-md-6"
                                    classLabel="col-md-6"
                                    labelTitle={t(`item.ticket.assigner`)}
                                >
                                    <Span>{ticket.assignerName}</Span>
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    isRequired={'right'}
                                    typeInput={true}
                                    messageBelowInput={true}
                                    classInputForm="col-md-8"
                                    classLabel="col-md-4"
                                    dataValidation={ticket.assigneeId}
                                    validation={validation.assigneeId}
                                    labelTitle={t(`item.ticket.assignee`)}
                                >
                                    <AntSelect className="select-destination"
                                        showArrow showSearch
                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.ticket.assignee")).toLowerCase())}
                                        value={ticket.assigneeId}
                                        onChange={id => this.onChangeDetail('assigneeId', id)}
                                        style={{ width: '100%' }}
                                        filterOption={this.selectFilterSearch}
                                    >
                                        {csUsers.map(user => (
                                            <AntOption key={user.id} value={user.id}>{getLocaleFullName(user.firstname, user.lastname)}</AntOption>
                                        ))}
                                    </AntSelect>
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    typeInput={true}
                                    classInputForm="col-md-6"
                                    classLabel="col-md-6"
                                    labelTitle={t(`item.ticket.createdDate`)}
                                >
                                    <Span>{ticket.createdDate && ticket.createdDate.format(DATE_TIME_FORMAT.DATE_TIME)}</Span>
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    typeInput={true}
                                    classInputForm="col-md-6"
                                    classLabel="col-md-6"
                                    labelTitle={t(`item.ticket.openedTime`)}
                                >
                                    <Span>{ticket.openedTime && ticket.openedTime.format(DATE_TIME_FORMAT.DATE_TIME)}</Span>
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    typeInput={true}
                                    classInputForm="col-md-6"
                                    classLabel="col-md-6"
                                    labelTitle={t(`item.ticket.closedTime`)}
                                >
                                    <Span>{ticket.closedTime && ticket.closedTime.format(DATE_TIME_FORMAT.DATE_TIME)}</Span>
                                </FormWrapperInputComponent>
                            </Wrapper>
                            <Wrapper className="col-md-6">
                                <Wrapper className="row">
                                    <FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={ticket.contactFirstName}
                                        validation={validation.contactFirstName}
                                        labelTitle={t(`item.ticket.contactFirstName`)}
                                        className="col-md-6"
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`contactFirstName`} onChange={(e) => this.onChangeDetail('contactFirstName', e.target.value)}
                                            value={Func.checkUndefine(ticket.contactFirstName)} />
                                    </FormWrapperInputComponent>
                                    <FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={ticket.contactLastName}
                                        validation={validation.contactLastName}
                                        labelTitle={t(`item.ticket.contactLastName`)}
                                        className="col-md-6"
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`contactLastName`} onChange={(e) => this.onChangeDetail('contactLastName', e.target.value)}
                                            value={Func.checkUndefine(ticket.contactLastName)} />
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <FormWrapperInputComponent
                                    isRequired={true}
                                    isValidation={true}
                                    dataValidation={ticket.contactEmail}
                                    validation={validation.contactEmail}
                                    labelTitle={t(`item.ticket.contactEmail`)}
                                >
                                    <Input placeholder="" type={`text`}
                                        className={`form-control`}
                                        name={`contactEmail`} onChange={(e) => this.onChangeDetail('contactEmail', e.target.value)}
                                        value={Func.checkUndefine(ticket.contactEmail)} />
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    isRequired={true}
                                    isValidation={true}
                                    dataValidation={ticket.contactPhone}
                                    validation={validation.contactPhone}
                                    labelTitle={t(`item.ticket.contactPhone`)}
                                >
                                    <Input placeholder="" type={`text`}
                                        className={`form-control`}
                                        name={`contactPhone`} onChange={(e) => this.onChangeDetail('contactPhone', e.target.value)}
                                        value={Func.checkUndefine(ticket.contactPhone)} />
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    labelTitle={t(`item.ticket.notes`)}
                                >
                                    <TextArea value={Func.checkUndefine(ticket.notes)}
                                        placeholder={t(`item.ticket.notes`)}
                                        onChange={e => this.onChangeDetail('notes', e.target.value)} />
                                </FormWrapperInputComponent>
                            </Wrapper>

                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        const { match, ticketState, isMyTicket, ticketId } = this.props;
        let ticket = this.state.ticket;
        if (isMyTicket || (Object.keys(match.params).length > 0 && match.params.id)) {
            const tickets = isMyTicket ? ticketState.myTickets : ticketState.tickets;
            const id = isMyTicket ? ticketId : match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            ticket = find(tickets, item => item.id === id) || ticket;
            if (ticket) this.setState({ ticket });
            if (isMyTicket) {
                this.props.getMyTicketDetail(id);
            } else {
                this.props.getTicketDetail(id);
            }
        }
        this.props.getCSUsers();
    }

    onChangeDetail = (fieldName, value) => {
        const ticket = this.state.ticket;
        ticket[fieldName] = value;
        this.setState({ ticket });
    };

    onSubmit = (e) => {
        if (e) e.preventDefault();
        if (this.validate()) {
            this.updateDetail()
        }
    };

    onClickBack = () => {
        this.props.history.push(PATHS.TICKET.LIST.path);
    }

    validate(reset = false) {
        const { t } = this.props;
        const { ticket } = this.state;
        if (reset) {
            Func.multipleValidate(ticket, undefined, {});
            this.setState({ validation: {} });
        }
        let validate = {
            required: {
                ticketName: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ticket.ticketName`)),
                contactFirstName: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ticket.contactFirstName`)),
                contactLastName: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ticket.contactLastName`)),
                contactEmail: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ticket.contactEmail`)),
                contactPhone: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ticket.contactPhone`)),
                assigneeId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.ticket.assignee`)),
            },
            isPhone: {
                contactPhone: t('validation.isPhone'),
            },
            isEmail: {
                contactEmail: t('validation.email'),
            },
        };
        let valueValidate = {};
        const result = Func.multipleValidate(ticket, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    updateDetail() {
        const { ticket } = this.state;
        if (this.props.isMyTicket) {
            this.props.updateMyTicket(ticket);
        } else {
            this.props.updateTicket(ticket);
        }
        this.props.onUpdateTicket(ticket)
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

}

TicketDetail.defaultProps = {
    isMyTicket: false,
    onUpdateTicket: ticket => { },
}
